import {
    AUTH_CONFIRMED_ACTION,
    AUTH_FAILED_ACTION,
    CONSENT_RESPONSE,
    FETCHED_USER_CANCEL_ACTION,
    FETCHED_USER_SUCCESS_ACTION,
    FETCH_PRIVILEGES,
    FETCH_USER_SUCCESS_ACTION,
    LOADING_TOGGLE_ACTION,
    LOGIN_CONFIRMED_ACTION,
    LOGIN_FAILED_ACTION,
    LOGOUT_ACTION,
    SIGNUP_CONFIRMED_ACTION,
    SIGNUP_FAILED_ACTION,
} from '../actions/AuthActions';

const initialState = {
    auth: {
        email: '',
        consentMessage: '',
        consentResponse: false,
        token: '',
        localId: '',
        expiresIn: '',
        refreshToken: '',
    },
    errorMessage: '',
    successMessage: '',
    showLoading: false,
    user:''
};

export function AuthReducer(state = initialState, action) {
    if (action.type === SIGNUP_CONFIRMED_ACTION) {
        return {
            ...state,
            auth: action.payload,
            errorMessage: '',
            successMessage: 'Signup Successfully Completed',
            showLoading: false,
        };
    }
    if (action.type === FETCH_PRIVILEGES) {
        return {
            ...state,
            privileges: action.payload,
        };
    }
    if (action.type === LOGIN_CONFIRMED_ACTION) {
        return {
            ...state,
            auth: action.payload,
            consentMessage: action.payload.consentMessage,
            errorMessage: '',
            successMessage: 'Login Successfully Completed',
            showLoading: false,
            showOtpField: false,
            confirmDetails:false
        };
    }
    if (action.type === AUTH_CONFIRMED_ACTION) {
        return {
            ...state,
            auth: action.payload,
            errorMessage: '',
            successMessage: action.payload,
            showLoading: false,
            showOtpField: true,
        };
    }

    if (action.type === LOGOUT_ACTION) {
        sessionStorage.removeItem('consentSubmitted');
        return {
            ...state,
            errorMessage: '',
            successMessage: '',
            auth: {
                auth:'',
                email: '',
                consentMessage: '',
                token: '',
                localId: '',
                expiresIn: '',
                refreshToken: '',
                user:'',
                showLoading: false,
                showOtpField: false,
                confirmDetails:false
            },
        };
    }

    if (
        action.type === SIGNUP_FAILED_ACTION ||
        action.type === LOGIN_FAILED_ACTION || action.type === AUTH_FAILED_ACTION
    ) {
        return {
            ...state,
            errorMessage: action.payload,
            successMessage: '',
            showLoading: false,
        };
    }

    if (action.type === LOADING_TOGGLE_ACTION) {
        return {
            ...state,
            showLoading: action.payload,
        };
    }
    if(action.type === FETCH_USER_SUCCESS_ACTION){
        return {
            ...state,
            user:action.payload
        }
    }
    if(action.type === FETCHED_USER_SUCCESS_ACTION){
        return {
            ...state,
            user:action.payload,
            confirmDetails:true
        }
    }
    if(action.type === FETCHED_USER_CANCEL_ACTION){
        return {
            ...state,
            confirmDetails:false
        }
    }
    if(action.type === CONSENT_RESPONSE){
        return {
            ...state,
            consentActionResponse:action.payload
        }
    }
    return state;
}


